import React from "react";

const Footer = () => {

    return (
        <footer id="footer">

            <div className="container">

                <div className="copyright-wrap d-md-flex py-4">
                    <div className="me-md-auto text-center text-md-start">
                        <div className="copyright">
                            &copy; Copyright <strong><span>RSoft</span></strong>. All Rights Reserved
                        </div>
                        <div className="credits">
                            Designed by <a href="https://bootstrapmade.com/">Ricardo Pari</a>
                        </div>
                    </div>
                    <div className="social-links text-center text-md-right pt-3 pt-md-0">
                        <a href="https://twitter.com/rsoft_latam" className="twitter">
                            <i className="bx bxl-twitter"/>
                        </a>
                        <a href="https://www.facebook.com/RsoftLatam" className="facebook">
                            <i className="bx bxl-facebook"/>
                        </a>
                        <a href="https://www.youtube.com/c/rsoftlatam" className="youtube">
                            <i className="bx bxl-youtube"/>
                        </a>
                        <a href="https://github.com/rsoft-latam" className="github">
                            <i className="bx bxl-github"/>
                        </a>
                        <a href="https://www.linkedin.com/in/ricardo-pari-534070139" className="linkedin">
                            <i className="bx bxl-linkedin"/>
                        </a>
                    </div>
                </div>

            </div>
        </footer>
    )

}

export default Footer;
